/* RESPONSIBLE TEAM: team-proactive-support */
import ManageMessagesSettingsRoute from 'embercom/routes/apps/app/settings/base/manage-messages-settings-route';

export default class EmailTemplatesRoute extends ManageMessagesSettingsRoute {
  analytics = {
    section: 'settings',
    place: 'proactive_support',
    object: 'email_templates',
  };
}
